// this is an autogenerated file from App/Account/Content/Settings/Content/TreatmentAutomations/copy-events-mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_TreatmentAutomations(
  $event_ids: [uuid!]!
  $target_location_ids: [uuid!]!
) {
  events_events_copy(
    event_ids: $event_ids
    target_location_ids: $target_location_ids
  ) {
    ok
  }
}

`